import { useState } from 'react';
import { Button, Form, Input, Modal, message } from 'antd';

import { duplicateProject } from '../../api/data';
import { Project } from '../../@types/projects/types';
import { useSelected } from '../../providers/selectedContext';

type DuplicateProjectModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: (project: Project) => void;
};

const DuplicateProjectModal = ({
  open,
  onClose,
  onSuccess
}: DuplicateProjectModalProps) => {
  const { selectedInfo } = useSelected();
  const [projectName, setProjectName] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleDuplicate = async () => {
    if (!selectedInfo.project?.uid) {
      return;
    }

    setSubmitting(true);
    try {
      const duplicatedProject = await duplicateProject(selectedInfo.project.uid, {
        project_name: projectName.trim() || undefined
      });
      message.success('Project duplicated successfully');
      onSuccess(duplicatedProject);
      setProjectName('');
      onClose();
    } catch (error) {
      message.error('Unable to duplicate project');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setProjectName('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      title="Duplicate Project"
    >
      <Form layout="vertical">
        <Form.Item
          label="New project title"
          extra="Leave blank to use an automatic copy name."
        >
          <Input
            aria-label="New project title"
            value={projectName}
            onChange={event => setProjectName(event.target.value)}
            placeholder={`${selectedInfo.project?.project_name || 'Project'} Copy`}
          />
        </Form.Item>
      </Form>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button type="primary" loading={submitting} onClick={handleDuplicate}>
          Duplicate Project
        </Button>
      </div>
    </Modal>
  );
};

export default DuplicateProjectModal;
